import {Component, OnInit} from '@angular/core';
import {CookieService} from './modules/core/session/cookie.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: []
})
export class AppComponent implements OnInit {
  showCookieBanner = true;

  constructor(
    private readonly cookieService: CookieService
  ) { }

  ngOnInit(): void {
    if (this.cookieService.checkCookie('SKVCookieAlert')) {
      this.showCookieBanner = false;
    }
  }

  onCookieSet(): void {
    this.showCookieBanner = false;
  }
}
